import React, { useEffect, useState, useRef } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { TableBaseStyle, EMCTrendStyle } from './EMCTrendStyle';
import {
  GetEMCTrendDatas,
  EMCAlarmInfoModel,
  ConvertDateToStringByString,
  ConvertDateToStringByDate,
} from './EMCTrend';
import ColorLineText from '../../atoms/Text/ColorLineText';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

type EMCTrendGridProps = {
  emcAlarmInfoModel: EMCAlarmInfoModel[];
  chartSelectData: string;
  onLineDispCkeckBoxChange: (itemNo: string) => void;
  onLineDispAllOff: () => void;
};
const EMCTrendGrid: React.FC<EMCTrendGridProps> = (props) => {
  const tableStyle = TableBaseStyle();
  const emcTrendStyle = EMCTrendStyle();
  const { t } = useTranslation();

  const allDispCheckFlg = React.useRef<boolean>(true);
  /**
   * 上位にデータ変更通知
   * @param editRow　編集対象データ
   * @param isEdit 編集フラグ
   * @returns
   */
  const onChangeData = (editRow: EMCAlarmInfoModel, editFlg: boolean) => {
    if (editFlg) {
      //console.debug(['onChangeData - editRow,baseData', editRow, props.studySet1]);
      //props.onChangeData(editRow);
    }
  };

  /**
   * 画面アラーム情報種類のグリッドデータ
   * @param target
   * @param kindNo
   * @param title
   * @returns
   */
  const getAlarmKindData = (target: EMCAlarmInfoModel[], kindNo: string, title: string) => {
    const list = target.filter((r) => r.AlarmKind === kindNo);

    /**
     * 出力列に出力するデータ
     * @param index
     * @returns
     */
    const getValue = (index: number): string => {
      var dIndex = list[index].TrendGraphDatas.findIndex(
        (r) => ConvertDateToStringByDate(r.ColData) === ConvertDateToStringByString(props.chartSelectData)
      );
      if (dIndex !== -1) {
        if (list[index].TrendGraphDatas[dIndex].RawValue === null) {
          return '';
        } else {
          return String(list[index].TrendGraphDatas[dIndex].RawValue.toFixed(0));
        }
      } else {
        return '';
      }
    };

    return (
      <>
        <TableRow>
          <TableCell className={tableStyle.bodyCellCenter} rowSpan={list.length + 1} width={80}>
            {title}
          </TableCell>
        </TableRow>
        {list.map((row, index) => {
          return (
            <TableRow key={index}>
              <TableCell className={tableStyle.bodyCellCenter} width={40}>
                <input
                  className={emcTrendStyle.checkBox}
                  type="checkbox"
                  value="js"
                  onChange={(e) => props.onLineDispCkeckBoxChange(row.ItemNo)}
                  checked={row.IsDisplay}
                />
              </TableCell>
              <TableCell className={tableStyle.bodyCell} width={260}>
                <div style={{ display: 'inline-block' }}>
                  <ColorLineText color={row.ChartLineColor} width={'20px'} height={'8px'}></ColorLineText>
                </div>
                <div style={{ display: 'inline-block' }}>{row.ItemName}</div>
              </TableCell>
              <TableCell className={tableStyle.bodyCellCenter} width={40}>
                {getValue(index)}
              </TableCell>
              <TableCell className={tableStyle.bodyCellCenter} width={40}>
                {row.UNIT}
              </TableCell>
            </TableRow>
          );
        })}
      </>
    );
  };

  return (
    <>
      <div>
        {ConvertDateToStringByString(props.chartSelectData) !== ''
          ? ConvertDateToStringByString(props.chartSelectData)
          : '----/--/-- --:--:--'}
      </div>
      <TableContainer component={Paper} className={emcTrendStyle.tableContainer}>
        <Table stickyHeader size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell className={tableStyle.headerCell} width={'50px'}>
                {t('EMCTrendGrid.異常', '異常')}
              </TableCell>
              <TableCell className={tableStyle.headerCell}>
                {t('EMCTrendGrid.表示', '表示')}
                <input
                  className={emcTrendStyle.checkBox}
                  type="checkbox"
                  value="js"
                  onChange={(e) => {
                    allDispCheckFlg.current = !allDispCheckFlg.current;
                    props.onLineDispAllOff();
                  }}
                  checked={allDispCheckFlg.current}
                />
              </TableCell>
              <TableCell className={tableStyle.headerCell}>{t('EMCTrendGrid.項目', '項目')}</TableCell>
              <TableCell className={tableStyle.headerCell}>{t('EMCTrendGrid.出力', '出力')}</TableCell>
              <TableCell className={tableStyle.headerCell}>{t('EMCTrendGrid.単位', '単位')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {getAlarmKindData(props.emcAlarmInfoModel, '1', t('EMCTrendGrid.軸受', '軸受'))}
            {getAlarmKindData(props.emcAlarmInfoModel, '2', t('EMCTrendGrid.機械系', '機械系'))}
            {getAlarmKindData(props.emcAlarmInfoModel, '3', t('EMCTrendGrid.回転子', '回転子'))}
            {getAlarmKindData(props.emcAlarmInfoModel, '4', t('EMCTrendGrid.レアショート', 'レアショート'))}
            {getAlarmKindData(props.emcAlarmInfoModel, '5', t('EMCTrendGrid.トルク', 'トルク'))}
            {getAlarmKindData(props.emcAlarmInfoModel, '6', '')}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default EMCTrendGrid;
